/*! cln-pdp09 — interaction transplant (1:1 clone) + BUY-BOX commerce UX
 *
 * Drives the captured static rendered DOM. Gallery / drawers / reveal /
 * sticky are unchanged 1:1 ports. The BUY-BOX commerce layer is rebuilt
 * to the proven reference offer-PDP pattern (same maison/liquid-ajax-cart theme):
 *   - color selection = radio-row pattern (radio dot + name + thumbnail)
 *       SINGLE (1x offer): ONE color row (device 1)
 *       BUNDLE (2x offer): TWO numbered color rows ("Apparaat 1" / "Apparaat 2")
 *   - color -> main product image swap (owner-explicit; White->images[10], Grey->images[9])
 *   - add-to-cart = AJAX POST /cart/add.js -> POST /cart/update.js {sections:maison-cart-drawer}
 *     -> window.reloadCart() -> window.openCart() (the LIVE theme's global drawer API).
 *     NEVER redirects to /cart. Fallbacks: click #cart-icon-bubble, then body.js-show-ajax-cart.
 *   - 1x = one line item (selected variant); 2x = two line items (dev1 + dev2), each
 *     carrying _mxr_offer / _mxr_offer_route / _mxr_offer_currency so the cart-level
 *     bundle discount applies (historical carrier metadata; current price is enforced by the active automatic discount).
 *
 * REAL selectors targeted (captured rendered DOM):
 *   Root .......................... section.cln-pdp09[data-cln-slot="CLN-PDP09"]
 *   Gallery main image ............ img[data-dc-tpl="24"]
 *   Gallery swipe / prev / next ... [data-dc-tpl="23"] / "25" / "26"
 *   Gallery counter / thumbs ...... [data-dc-tpl="27"] / [data-dc-tpl="28"] button[aria-pressed]
 *   Color UI container ............ [data-cln-color-ui] (data-cln-white-id/grey-id/white-img/grey-img)
 *   Hero device-1 rows ............ [data-cln-dev1="white"] (=tpl 41) / [data-cln-dev1="grey"] (=tpl 43)
 *   Hero device-2 rows ............ [data-cln-dev2="white"] / [data-cln-dev2="grey"] inside [data-cln-dev="2"]
 *   Hero device-2 wrapper ......... [data-cln-dev-row][data-cln-dev="2"] (shown only for 2x)
 *   Hero offer radios ............. [data-dc-tpl="34"] (1x) / [data-dc-tpl="37"] (2x)
 *   Hero/sticky price ............. [data-dc-tpl="31"] / [data-dc-tpl="319"]
 *   Big offer cards ............... [data-dc-tpl="234"] (1x) / [data-dc-tpl="238"] (2x)
 *   Offer-section form ............ form[data-cln-buy-form]
 *   Offer-form dual-color block ... [data-cln-dual-color] (its own dev1/dev2 buttons)
 *   Line inputs ................... [data-cln-variant-id]/[data-cln-line0-id], [data-cln-second-line], [data-cln-line1-prop]
 *   Buy CTAs ...................... [data-cln-buy-cta] (hero tpl45 / form tpl253 / sticky tpl321)
 *   Scroll CTAs (no add) .......... [data-cln-scroll-cta] (header tpl11 / closer tpl301)
 *   Mechanism glow ................ [data-dc-tpl="95"]/"96" (red glow, static — I12
 *                                   removed the dead side-toggle JS; tpl 99/100
 *                                   buttons are being removed by B-SECTION-2)
 *   Disclosure toggles ............ button[data-toggle][aria-controls]
 *   Sticky buy-bar ................ [data-dc-tpl="316"] (price [data-dc-tpl="319"])
 *
 * 2026-07-02 production polish (local staged build):
 *   P0-1  setOffer() now ALSO repaints the HERO offer radios (tpl 34/37).
 *         They ship with static inline border/background, so a CSS rule on
 *         [aria-checked] can never win — paint follows the proven ROW/TILE
 *         style-tail pattern + a JS-injected radio ring/dot.
 *   P0-3  JS-generated media lightbox (.cln-pdp09-lb, appended inside the
 *         section root): dialog semantics, focus trap, iOS-safe scroll lock,
 *         prev/next/keys/swipe, counter, 2048px renditions via data-cln-full
 *         (fallback: width-param rewrite), gallery <video> sources reused.
 *   i18n  UI strings read from section-root data-cln-i18n-* attrs (NL fallback).
 *   Prices read from section-root data-cln-price-1x/-2x/-2x-save (fallback
 *         249/449 €; no savings claim); all JS price writes (tpl31/tpl319) use that source.
 *   ATC   busy-state on all [data-cln-buy-cta], double-click guard, visible
 *         role=alert error near the triggering CTA (clears on new selection).
 *
 * 2026-07-02 issues-v2 window 3 — FASE 1 (local staged build, B-JS-2):
 *   I1    sticky top-CTA stacking fix lives in cln-pdp09.css (bar z 50 -> 2,
 *         under the theme header's z:3 stacking context that holds the open
 *         language-selector dropdown). No JS needed.
 *   I3c   setDevColor(): the gallery color-jump now runs for BOTH device rows
 *         (dev1 AND dev2) — clicking any of the 4 color rows jumps the main
 *         gallery to that color's slide. Variant selection side-effects are
 *         unchanged (state.dev1/dev2, paint, cart-input sync as before).
 *   I6    drawer auto-collapse: every [data-toggle] panel (7 depth drawers +
 *         8 primary FAQ items) closes itself once its open content is fully
 *         ABOVE the viewport while scrolling down. Scroll position is
 *         compensated by the exact document-height delta in the same frame
 *         (zero visual jump); deferred while the smooth scroll-CTA jump is
 *         in flight so that animation is never cancelled mid-way.
 *   I7    lightbox preload: on open and on every navigation the adjacent
 *         slides (n-1 / n+1) are prefetched — images via new Image() on the
 *         data-cln-full 2048px rendition, videos poster-only (never media).
 *   I12   dead Mechanism side-toggle JS removed (setSide + tpl 99/100
 *         listeners); the red glow (tpl 95/96) keeps its server-rendered
 *         state. B-SECTION-2 removes the buttons from the markup.
 *
 * 2026-07-02 issues-v2 window 3 — FASE 2 (vote winners, VOTE-RESULTS.md):
 *   t5-A  comparison-table mobile switcher: segmented control built
 *         DOM-driven from the .p09-cmp column headers (per-language),
 *         default = [data-cln-cmp-default] competitor; non-active
 *         competitor cells -> .p09-cmp-off (hidden <920px via CSS).
 *   t6    offer-recap: syncRecap() mirrors offer/colors/price from the
 *         existing `state` into [data-cln-recap-offer|colors|price];
 *         [data-cln-recap-cta] smooth-scrolls to the hero buybox (tpl 29)
 *         and focuses the first offer tile (tpl 34). Reduced-motion aware.
 *   t7-B  carousel driver for .p09-carousel: arrow paging, end
 *         disabled-states, 2px progressbar (scaleX), keyboard arrows.
 *   t1/t3/t4/t8/t2/I2 are CSS-only (cln-pdp09.css fase-2 block).
 *   All fase-2 modules are defensive no-ops until the markup hooks exist.
 */
(function () {
  'use strict';

  var WHITE_VARIANT = '56070970966360';
  var GREY_VARIANT  = '56070970999128';
  var OFFER_KEY     = 'r9k2v5';
  var OFFER_PROPS   = {
    _mxr_offer: 'view_' + OFFER_KEY,
    _mxr_offer_route: 'page.' + OFFER_KEY,
    _mxr_offer_currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
  };
  var CART_DRAWER_SECTION = 'maison-cart-drawer';

  var REDUCED = false;
  try {
    REDUCED = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { REDUCED = false; }

  function $(root, sel) { return root.querySelector(sel); }
  function $all(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function setInterp(el, txt) {
    if (!el) return;
    var i = el.querySelector ? el.querySelector('.sc-interp') : null;
    (i || el).textContent = txt;
  }

  function initRoot(root) {
    if (!root || root.__clnPdp09Init) return;
    root.__clnPdp09Init = true;
    var preserveResponsiveGallery = root.classList.contains('fable-variant-b') &&
      root.getAttribute('data-cln-token') === 'r9k2v5';

    // ---- i18n + market price strings (section-root data-attrs, NL fallback) --
    // The section builder sets these on <section class="cln-pdp09" ...>; until
    // it does, the fallbacks keep today's hardcoded NL/EUR behavior 1:1.
    function rootAttr(name, fallback) {
      var v = root.getAttribute(name);
      return (v === null || v === '') ? fallback : v;
    }
    var I18N = {
      soundOn:  rootAttr('data-cln-i18n-sound-on',  'Geluid aan'),
      soundOff: rootAttr('data-cln-i18n-sound-off', 'Geluid uit'),
      selected: rootAttr('data-cln-i18n-selected',  'Geselecteerd'),
      lbClose:  rootAttr('data-cln-i18n-lb-close',  'Sluiten'),
      lbPrev:   rootAttr('data-cln-i18n-lb-prev',   'Vorige'),
      lbNext:   rootAttr('data-cln-i18n-lb-next',   'Volgende'),
      lbOpen:   rootAttr('data-cln-i18n-lb-open',   'Vergroot afbeelding'),
      atcError: rootAttr('data-cln-i18n-atc-error', 'Toevoegen mislukt. Probeer het opnieuw.')
    };
    // pre-formatted per-market price strings; every JS price write (hero price
    // tpl31, sticky price tpl319) reads from this map — no hardcoded amounts.
    var PRICES = {
      1: rootAttr('data-cln-price-1x', '249 €'),
      2: rootAttr('data-cln-price-2x', '449 €'),
      save2x: rootAttr('data-cln-price-2x-save', '')
    };

    // ---- element handles ----------------------------------------------------
    // Gallery is now a block-driven slide stage: each [data-cln-slide] is an
    // image OR a video; thumbs are [data-cln-thumb]. Empty media blocks render
    // nothing (server-side), so slides/thumbs only exist for non-empty slots.
    var stage     = $(root, '[data-cln-stage]') || $(root, '[data-dc-tpl="23"]');
    var swipeBox  = stage;
    var slides    = stage ? $all(stage, '[data-cln-slide]') : [];
    var prevBtn   = $(root, '[data-dc-tpl="25"]');
    var nextBtn   = $(root, '[data-dc-tpl="26"]');
    var counter   = $(root, '[data-dc-tpl="27"]');
    var thumbWrap = $(root, '[data-cln-thumbs]') || $(root, '[data-dc-tpl="28"]');
    var thumbs    = thumbWrap ? $all(thumbWrap, '[data-cln-thumb]') : [];
    // legacy single-image handle kept for any external reference; not required.
    var mainImg   = $(root, '[data-dc-tpl="24"]');

    var heroOff1  = $(root, '[data-dc-tpl="34"]');
    var heroOff2  = $(root, '[data-dc-tpl="37"]');
    var heroPrice = $(root, '[data-dc-tpl="31"]');
    var bigOff1   = $(root, '[data-dc-tpl="234"]');
    var bigOff2   = $(root, '[data-dc-tpl="238"]');

    // I12: mechanism side-toggle handles (tpl 95/96 glow, 99/100 buttons)
    // removed together with the dead setSide() logic below — the red glow
    // keeps its server-rendered inline state, untouched by JS.

    var heroCta   = $(root, '[data-hero-cta]');
    var offerSec  = $(root, '[data-offer-sec]');
    var footer    = $(root, '[data-footer]');
    var sticky    = $(root, '[data-dc-tpl="316"]');
    var stickyPr  = $(root, '[data-dc-tpl="319"]');

    // color UI (hero) + image-swap sources read from the DOM (no hard coupling)
    var colorUI   = $(root, '[data-cln-color-ui]');
    var dev2Wrap  = colorUI ? $(colorUI, '[data-cln-dev-row][data-cln-dev="2"]') : null;
    if (colorUI) {
      WHITE_VARIANT = colorUI.getAttribute('data-cln-white-id') || WHITE_VARIANT;
      GREY_VARIANT  = colorUI.getAttribute('data-cln-grey-id')  || GREY_VARIANT;
    }
    var IMG_WHITE = (colorUI && colorUI.getAttribute('data-cln-white-img')) || null;
    var IMG_GREY  = (colorUI && colorUI.getAttribute('data-cln-grey-img'))  || null;
    // slide index of the white/grey device image (server-computed); -1 if absent.
    function readIdx(attr) {
      var v = colorUI ? parseInt(colorUI.getAttribute(attr), 10) : -1;
      return (isNaN(v) ? -1 : v);
    }
    var IDX_WHITE = readIdx('data-cln-white-idx');
    var IDX_GREY  = readIdx('data-cln-grey-idx');

    // hero device rows (the color UI block holds device 1's rows + device 2 wrapper)
    var hDev1White = colorUI ? $(colorUI, '[data-cln-dev1="white"]') : $(root, '[data-cln-dev1="white"]');
    var hDev1Grey  = colorUI ? $(colorUI, '[data-cln-dev1="grey"]')  : $(root, '[data-cln-dev1="grey"]');
    var hDev2White = colorUI ? $(colorUI, '[data-cln-dev2="white"]') : null;
    var hDev2Grey  = colorUI ? $(colorUI, '[data-cln-dev2="grey"]')  : null;
    var hDev1Label = colorUI ? $(colorUI, '[data-cln-dev-label]')    : null;

    // offer-section form + its dual-color block
    var buyForm   = $(root, 'form[data-cln-buy-form]');
    var dualColor = $(root, '[data-cln-dual-color]');
    var fDev1White = dualColor ? $(dualColor, '[data-cln-dev1="white"]') : null;
    var fDev1Grey  = dualColor ? $(dualColor, '[data-cln-dev1="grey"]')  : null;
    var fDev2White = dualColor ? $(dualColor, '[data-cln-dev2="white"]') : null;
    var fDev2Grey  = dualColor ? $(dualColor, '[data-cln-dev2="grey"]')  : null;

    // hidden cart inputs (native no-JS fallback)
    var line0Id   = $(root, '[data-cln-line0-id]') || $(root, '[data-cln-variant-id]');
    var line1Id   = $(root, '[data-cln-second-line]');
    var line1Props = $all(root, '[data-cln-line1-prop]');

    function variantFor(c) { return c === 'white' ? WHITE_VARIANT : GREY_VARIANT; }
    function imgFor(c) { return c === 'white' ? IMG_WHITE : IMG_GREY; }

    // ---- state --------------------------------------------------------------
    // dev1/dev2 = per-device colors (dev1 also = the single-offer color).
    // (I12: `side` removed together with the dead mechanism side-toggle.)
    var state = { mainIdx: 0, offer: 1, sticky: false,
                  dev1: 'white', dev2: 'white' };

    // ---- gallery (block-driven slide stage; image OR video per slide) -------
    var SLIDE_COUNT = slides.length;

    function slideEl(i) { return slides[i] || null; }
    function videoIn(slideNode) {
      return slideNode ? slideNode.querySelector('video.cln-gallery-video, video') : null;
    }
    // strip srcset/sizes off any image so a later .src swap actually shows.
    // PERF fix 1: skip video-poster <img>s — they are placeholders that never get
    // a color-swap, and keeping their srcset preserves the responsive rendition.
    if (!preserveResponsiveGallery) {
      slides.forEach(function (sl) {
        var im = sl.querySelector('img');
        if (im && !im.hasAttribute('data-cln-video-poster')) {
          if (im.hasAttribute('srcset')) im.removeAttribute('srcset');
          if (im.hasAttribute('sizes'))  im.removeAttribute('sizes');
        }
      });
    }

    function updateCounter() {
      if (counter) setInterp(counter, (state.mainIdx + 1) + ' / ' + (SLIDE_COUNT || 1));
    }
    function markThumb() {
      thumbs.forEach(function (b, i) {
        var sel = i === state.mainIdx;
        b.setAttribute('aria-pressed', sel ? 'true' : 'false');
        b.style.border = '2px solid ' + (sel ? 'var(--bronze)' : 'transparent');
        // BRP-v70 F3 (T1-03): actieve thumb horizontaal in beeld houden in de
        // scrollbare strip. Bewust GEEN scrollIntoView (kan de pagina verticaal
        // meescrollen); alleen scrollLeft op de strip zelf.
        if (sel && thumbWrap) {
          try {
            var tr = b.getBoundingClientRect(), wr = thumbWrap.getBoundingClientRect();
            thumbWrap.scrollLeft += (tr.left + tr.width / 2) - (wr.left + wr.width / 2);
          } catch (e) {}
        }
      });
    }

    // ---- video control: guarantee only ONE gallery video plays at a time ----
    // PERF fix 1 (poster-first): the gallery <video> ship WITHOUT a <source>
    // child + preload="none", so no MP4 is fetched on load. ensureVideoLoaded()
    // injects the <source> (from data-cln-video-src) exactly once and calls
    // load(); playback only ever starts AFTER that. A gallery-level
    // IntersectionObserver gates auto-activation so an off-screen (no-scroll)
    // gallery never triggers a load — the active slide's video only loads once
    // the gallery is actually in view (or the user taps a slide/poster).
    function ensureVideoLoaded(v) {
      if (!v || v.__clnVidLoaded) return;
      var src = v.getAttribute('data-cln-video-src');
      if (!src) { v.__clnVidLoaded = true; return; } // nothing to load
      if (!v.querySelector('source')) {
        var s = document.createElement('source');
        s.src = src;
        var t = v.getAttribute('data-cln-video-type');
        if (t) s.type = t;
        v.appendChild(s);
        try { v.load(); } catch (e) {}
      }
      v.__clnVidLoaded = true;
    }
    // poster placeholder show/hide: the <img data-cln-video-poster> sits above
    // the <video> (z-index:1) until the video is loaded + playing.
    function posterIn(slideNode) {
      return slideNode ? slideNode.querySelector('[data-cln-video-poster]') : null;
    }
    function hidePoster(v) {
      if (!v) return;
      var p = posterIn(v.parentNode);
      if (p) { p.style.opacity = '0'; p.style.pointerEvents = 'none'; }
    }
    function showPoster(v) {
      if (!v) return;
      var p = posterIn(v.parentNode);
      if (p) { p.style.opacity = ''; p.style.pointerEvents = ''; }
    }
    function soundButtonIn(v) {
      if (!v) return;
      var wrap = v.parentNode;
      return wrap ? wrap.querySelector('[data-cln-unmute]') : null;
    }
    function syncSoundBtn(v) {
      if (!v) return;
      var btn = soundButtonIn(v);
      if (!btn) return;
      var on = !v.muted && v.volume > 0;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? I18N.soundOff : I18N.soundOn);
      var lab = btn.querySelector('[data-cln-unmute-label]');
      var ico = btn.querySelector('[data-cln-unmute-ico]');
      if (lab) lab.textContent = on ? I18N.soundOff : I18N.soundOn;
      if (ico) ico.textContent = on ? '🔊' : '🔇';
    }
    function ensureSoundButton(v) {
      if (!v || soundButtonIn(v)) return;
      var wrap = v.parentNode;
      if (!wrap) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-cln-unmute', '');
      btn.style.cssText = 'position:absolute;left:14px;bottom:14px;z-index:5;display:inline-flex;align-items:center;gap:7px;min-height:38px;padding:8px 12px;border:1px solid rgba(255,255,255,.72);border-radius:999px;background:rgba(24,22,20,.78);color:#fff;font:600 12px/1.1 var(--font-body);box-shadow:0 2px 12px rgba(0,0,0,.18);backdrop-filter:blur(6px);cursor:pointer;';
      var ico = document.createElement('span');
      ico.setAttribute('data-cln-unmute-ico', '');
      ico.setAttribute('aria-hidden', 'true');
      var lab = document.createElement('span');
      lab.setAttribute('data-cln-unmute-label', '');
      btn.appendChild(ico);
      btn.appendChild(lab);
      wrap.appendChild(btn);
      v.addEventListener('volumechange', function () { syncSoundBtn(v); });
      syncSoundBtn(v);
    }
    function resetUnmuteBtn(v) {
      if (!v) return;
      v.muted = true;
      syncSoundBtn(v);
    }
    slides.forEach(function (sl) { ensureSoundButton(videoIn(sl)); });
    function stopAllVideos(except) {
      slides.forEach(function (sl) {
        var v = videoIn(sl);
        if (!v || v === except) return;
        try { v.pause(); } catch (e) {}
        try { v.currentTime = 0; } catch (e) {}
        resetUnmuteBtn(v);
        showPoster(v); // paused video -> poster placeholder back on top
      });
    }
    // gallery in-view gate: only allow auto-activation once the gallery root is
    // (or has been) in the viewport. Until then, activateVideo() defers and just
    // remembers the pending video, so a no-scroll initial load fetches 0 MP4s.
    var galleryInView = false, pendingVideo = null;
    function isActiveGalleryVideo(v) {
      return v && videoIn(slideEl(state.mainIdx)) === v;
    }
    function playMutedFallback(v) {
      if (!isActiveGalleryVideo(v) || !galleryInView) return;
      v.muted = true;
      syncSoundBtn(v);
      var fallback = v.play();
      if (fallback && typeof fallback.then === 'function') {
        fallback.then(function () {
          if (isActiveGalleryVideo(v)) hidePoster(v);
        }).catch(function () { showPoster(v); });
      } else { hidePoster(v); }
    }
    function activateVideo(v) {
      if (!v) return;
      stopAllVideos(v);          // pause + reset + re-mute every other video
      if (!galleryInView) { pendingVideo = v; return; } // defer until in view
      pendingVideo = null;
      ensureVideoLoaded(v);      // inject <source> + load() on first activation
      try { v.currentTime = 0; } catch (e) {}
      // G5: first try playback with sound. Browsers may reject unmuted autoplay;
      // in that case fall back to muted autoplay and keep the one-tap sound
      // button visible. The button always mirrors the actual media mute state.
      v.muted = false;
      syncSoundBtn(v);
      try {
        var p = v.play();
        if (p && typeof p.then === 'function') {
          p.then(function () {
            if (isActiveGalleryVideo(v)) hidePoster(v);
          }).catch(function () { playMutedFallback(v); });
        } else { hidePoster(v); }
      } catch (e) { playMutedFallback(v); }
    }
    if (stage && ('IntersectionObserver' in window)) {
      var galIO = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          galleryInView = true;
          galIO.disconnect(); // one-shot: once in view, stay enabled
          // activate whatever the active slide is now (deferred video, if any)
          var cur = slideEl(state.mainIdx);
          var cv = videoIn(cur);
          if (cv) { activateVideo(cv); }
          else if (pendingVideo) { pendingVideo = null; }
        });
      }, { rootMargin: '80px 0px' });
      galIO.observe(stage);
    } else {
      // no IO support -> don't block interaction; treat gallery as in view.
      galleryInView = true;
    }

    // show slide i: toggle opacity/pointer-events; drive video play/pause.
    function ensureSlideImg(node) {
      if (!node) return;
      var im = node.querySelector('img[data-cln-src]');
      if (im && !im.getAttribute('src')) {
        var ss = im.getAttribute('data-cln-srcset');
        if (ss) { im.setAttribute('srcset', ss); }
        im.setAttribute('src', im.getAttribute('data-cln-src'));
      }
    }

    function showSlide(i) {
      if (!SLIDE_COUNT) return;
      state.mainIdx = i;
      slides.forEach(function (sl, idx) {
        var on = idx === i;
        sl.style.opacity = on ? '1' : '0';
        sl.style.pointerEvents = on ? 'auto' : 'none';
        // lightbox openers: only the visible slide is focusable / exposed to AT
        sl.setAttribute('tabindex', on ? '0' : '-1');
        sl.setAttribute('aria-hidden', on ? 'false' : 'true');
        // a11y (aria-hidden-focus): an aria-hidden slide must not keep focusable
        // descendants in the tab order. The unmute button is the only focusable
        // child (video slides only); take it out of tab order + hide from AT when
        // the slide is inactive, restore it when the slide becomes active. The
        // click-toggle listener (delegated on stage) is untouched, so behaviour
        // is identical once the slide is shown again.
        var foc = sl.querySelectorAll('[data-cln-unmute]');
        for (var fi = 0; fi < foc.length; fi++) {
          foc[fi].setAttribute('tabindex', on ? '0' : '-1');
          if (on) { foc[fi].removeAttribute('aria-hidden'); }
          else { foc[fi].setAttribute('aria-hidden', 'true'); }
        }
      });
      var cur = slideEl(i);
      // BRP-v70 F4 p3: stage-frame volgt de media-verhouding van de actieve slide.
      if (stage && cur) { stage.setAttribute('data-cln-stage-ratio', cur.getAttribute('data-cln-ratio') || 'wide'); }
      ensureSlideImg(cur);
      if (SLIDE_COUNT > 1) { ensureSlideImg(slides[(i + 1) % SLIDE_COUNT]); }
      var curVideo = videoIn(cur);
      if (curVideo) { activateVideo(curVideo); }
      else { stopAllVideos(null); } // leaving any video -> pause + reset + mute
      markThumb();
      updateCounter();
    }

    // jump to a slide by index (used by thumbs / arrows / swipe / color swatch).
    function setMainByIndex(i) {
      if (!SLIDE_COUNT) return;
      var n = SLIDE_COUNT;
      var idx = ((i % n) + n) % n;
      showSlide(idx);
    }
    // legacy color-swap entry: prefer index jump; fall back to src on the active
    // image slide (keeps working even if the white/grey image is not its own slide).
    function swapMain(src) {
      if (!src) return;
      var cur = slideEl(state.mainIdx);
      var im = cur ? cur.querySelector('img') : null;
      if (!im) return;
      if (!preserveResponsiveGallery) {
        if (im.hasAttribute('srcset')) im.removeAttribute('srcset');
        if (im.hasAttribute('sizes'))  im.removeAttribute('sizes');
      }
      im.src = src;
    }
    function galGo(dir) {
      if (!SLIDE_COUNT) return;
      setMainByIndex(state.mainIdx + dir);
    }
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () { setMainByIndex(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { galGo(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { galGo(1); });

    // unmute toggle on each video's overlay button (delegated within the stage).
    if (stage) {
      stage.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-cln-unmute]') : null;
        if (!btn || !stage.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        var wrap = btn.closest('[data-cln-slide]');
        var v = videoIn(wrap);
        if (!v) return;
        // PERF fix 1 (case b): a direct tap loads the source if it isn't yet,
        // marks the gallery in-view (explicit user intent) and hides the poster.
        galleryInView = true;
        ensureVideoLoaded(v);
        hidePoster(v);
        stopAllVideos(v);
        v.muted = !v.muted;
        syncSoundBtn(v);
        var pp = v.play();
        if (pp && typeof pp.then === 'function') {
          pp.then(function () { hidePoster(v); }).catch(function (err) {
            if (!isActiveGalleryVideo(v) || (err && err.name === 'AbortError')) return;
            v.muted = true;
            syncSoundBtn(v);
            var recover = v.play();
            if (recover && typeof recover.then === 'function') {
              recover.then(function () { hidePoster(v); }).catch(function () { showPoster(v); });
            } else { hidePoster(v); }
          });
        } else { hidePoster(v); }
      });
    }

    if (swipeBox) {
      var x0 = null, y0 = null;
      swipeBox.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      swipeBox.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) galGo(dx < 0 ? 1 : -1);
        x0 = null; y0 = null;
      }, { passive: true });
    }

    // ---- P0-3: media lightbox (fully JS-generated, class cln-pdp09-lb) ------
    // Built lazily on first open and appended INSIDE the section root, so every
    // .cln-pdp09-scoped CSS rule applies (incl. the reduced-motion blanket that
    // kills all animations/transitions). The active item collection is supplied
    // by the opener: gallery slides or UGC cards.
    var lbEl = null, lbStage = null, lbCount = null, lbCloseBtn = null,
        lbPrevBtn = null, lbNextBtn = null, lbVideo = null;
    var lbState = { open: false, idx: 0, opener: null, items: [], syncGallery: false };
    var scrollLock = { y: 0, on: false };

    function lbItem(node) {
      return {
        node: node,
        video: videoIn(node),
        image: node ? node.querySelector('img') : null
      };
    }
    var galleryLbItems = slides.map(lbItem);

    // iOS-safe body scroll-lock: remember scrollY, pin the body with
    // position:fixed, restore both on close.
    function lockScroll() {
      if (scrollLock.on) return;
      scrollLock.y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var b = document.body;
      b.style.position = 'fixed';
      b.style.top = (-scrollLock.y) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      b.style.overflow = 'hidden';
      scrollLock.on = true;
    }
    function unlockScroll() {
      if (!scrollLock.on) return;
      var b = document.body;
      b.style.position = ''; b.style.top = ''; b.style.left = '';
      b.style.right = ''; b.style.width = ''; b.style.overflow = '';
      scrollLock.on = false;
      window.scrollTo(0, scrollLock.y);
    }

    // Enlarged image source: prefer data-cln-full (2048px CDN rendition set by
    // the section builder); fallback = rewrite the width param on the existing
    // Shopify CDN src. Non-CDN sources pass through untouched.
    function fullSrcFor(im) {
      if (!im) return '';
      var full = im.getAttribute('data-cln-full');
      if (full) return full;
      var src = im.currentSrc || im.src || '';
      if (!src) return src;
      if (!/\/cdn\/shop\/|cdn\.shopify\.com/.test(src)) return src;
      if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=2048');
      return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=2048';
    }

    function lbBtn(cls, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cln-pdp09-lb-btn ' + cls;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      return b;
    }
    function buildLb() {
      if (lbEl) return;
      lbEl = document.createElement('div');
      lbEl.className = 'cln-pdp09-lb';
      lbEl.setAttribute('role', 'dialog');
      lbEl.setAttribute('aria-modal', 'true');
      lbEl.setAttribute('aria-label', I18N.lbOpen);
      lbEl.setAttribute('hidden', 'hidden');
      lbStage = document.createElement('div');
      lbStage.className = 'cln-pdp09-lb-stage';
      lbCloseBtn = lbBtn('cln-pdp09-lb-close', I18N.lbClose, '✕');
      lbPrevBtn  = lbBtn('cln-pdp09-lb-prev',  I18N.lbPrev,  '‹');
      lbNextBtn  = lbBtn('cln-pdp09-lb-next',  I18N.lbNext,  '›');
      lbCount = document.createElement('div');
      lbCount.className = 'cln-pdp09-lb-count';
      lbCount.setAttribute('aria-live', 'polite');
      lbEl.appendChild(lbStage);
      lbEl.appendChild(lbCloseBtn);
      lbEl.appendChild(lbPrevBtn);
      lbEl.appendChild(lbNextBtn);
      lbEl.appendChild(lbCount);
      root.appendChild(lbEl);

      lbCloseBtn.addEventListener('click', function () { closeLb(); });
      lbPrevBtn.addEventListener('click', function () { lbShow(lbState.idx - 1); });
      lbNextBtn.addEventListener('click', function () { lbShow(lbState.idx + 1); });
      // backdrop click (overlay or empty stage area) closes; media/buttons don't
      lbEl.addEventListener('click', function (e) {
        if (e.target === lbEl || e.target === lbStage) closeLb();
      });
      // touch swipe = prev/next (same 40px dominant-axis threshold as gallery)
      var tx = null, ty = null;
      lbStage.addEventListener('touchstart', function (e) {
        tx = e.touches[0].clientX; ty = e.touches[0].clientY;
      }, { passive: true });
      lbStage.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        var dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) lbShow(lbState.idx + (dx < 0 ? 1 : -1));
        tx = null; ty = null;
      }, { passive: true });
    }

    function lbPauseVideo() {
      if (!lbVideo) return;
      try { lbVideo.pause(); } catch (e) {}
      lbVideo.muted = true;
      lbVideo = null;
    }
    function lbShow(i) {
      var n = lbState.items.length;
      if (!n || !lbEl) return;
      lbState.idx = ((i % n) + n) % n;
      lbPauseVideo(); // navigating away always pauses the lightbox video
      while (lbStage.firstChild) lbStage.removeChild(lbStage.firstChild);
      var item = lbState.items[lbState.idx];
      var vid = item.video;
      if (vid) {
        // PERF fix 1 (case c): the gallery <video> has NO <source> child (poster-
        // first), so cloneNode DOESN'T copy a source and there is no double fetch
        // on open. The lightbox injects the source itself, on open only — this is
        // the intended, user-initiated load.
        var v = vid.cloneNode(true);
        v.className = 'cln-pdp09-lb-video';
        v.removeAttribute('style');
        v.removeAttribute('autoplay');
        v.removeAttribute('muted');
        v.removeAttribute('poster'); // full media in the lightbox, no poster flash
        v.setAttribute('preload', 'auto');
        v.setAttribute('controls', 'controls'); // native controls incl. mute-state
        v.setAttribute('playsinline', '');
        v.muted = false; // G5: user-initiated lightbox first tries sound on
        v.__clnVidLoaded = false;
        ensureVideoLoaded(v); // inject <source> from data-cln-video-src + load()
        lbVideo = v;
        lbStage.appendChild(v);
        try {
          var p = v.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () {
              if (lbVideo !== v) return;
              v.muted = true;
              var fallback = v.play();
              if (fallback && typeof fallback.catch === 'function') fallback.catch(function () {});
            });
          }
        } catch (e) {
          v.muted = true;
          try { v.play(); } catch (ignore) {}
        }
      } else {
        var srcIm = item.image;
        var im = document.createElement('img');
        im.className = 'cln-pdp09-lb-img';
        im.alt = srcIm ? (srcIm.getAttribute('alt') || '') : '';
        im.src = fullSrcFor(srcIm);
        lbStage.appendChild(im);
      }
      lbCount.textContent = (lbState.idx + 1) + ' / ' + n;
      lbPrevBtn.hidden = n < 2;
      lbNextBtn.hidden = n < 2;
      lbPreload(lbState.idx); // I7: prefetch the adjacent slides (n-1 / n+1)
    }

    // ---- I7: lightbox adjacent-slide preload (EXTENDS the frozen lightbox —
    // one added call at the end of lbShow(), no existing path is altered).
    // The next/prev enlarged renditions load in the background so navigating
    // no longer waits 2-3s on the 2048px image. Images only: video slides
    // prefetch just their poster frame, never the media itself. De-duped via
    // an URL cache, so repeated navigation costs nothing extra.
    var lbPreloaded = {};
    function lbPreload(i) {
      var n = lbState.items.length;
      if (!n) return;
      [i - 1, i + 1].forEach(function (k) {
        var idx = ((k % n) + n) % n;
        if (idx === i) return; // n<=2: neighbor collapses onto current
        var item = lbState.items[idx];
        if (!item) return;
        var vid = item.video;
        var url = vid ? (vid.getAttribute('poster') || '')
                      : fullSrcFor(item.image);
        if (!url && item.image) url = fullSrcFor(item.image);
        if (!url || lbPreloaded[url]) return;
        lbPreloaded[url] = true;
        var im = new Image();
        im.decoding = 'async';
        im.src = url;
      });
    }

    function lbFocusables() {
      return $all(lbEl, 'button, video[controls]');
    }
    function lbKeydown(e) {
      if (!lbState.open) return;
      var k = e.key;
      if (k === 'Escape' || k === 'Esc') { e.preventDefault(); closeLb(); return; }
      if (k === 'ArrowLeft')  { e.preventDefault(); lbShow(lbState.idx - 1); return; }
      if (k === 'ArrowRight') { e.preventDefault(); lbShow(lbState.idx + 1); return; }
      if (k === 'Tab') { // focus trap: cycle within the dialog
        var f = lbFocusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        var act = document.activeElement;
        if (e.shiftKey && (act === first || !lbEl.contains(act))) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && (act === last || !lbEl.contains(act))) {
          e.preventDefault(); first.focus();
        }
      }
    }

    function openLb(items, i, opener, syncGallery) {
      if (!items || !items.length) return;
      buildLb();
      lbState.items = items;
      lbState.opener = opener || null;
      lbState.syncGallery = Boolean(syncGallery);
      stopAllVideos(null); // gallery video pauses + re-mutes underneath
      lockScroll();
      lbEl.removeAttribute('hidden');
      lbState.open = true;
      lbShow(i);
      document.addEventListener('keydown', lbKeydown, true);
      lbCloseBtn.focus(); // initial focus on the close button
    }
    function closeLb() {
      if (!lbState.open || !lbEl) return;
      lbState.open = false;
      lbPauseVideo(); // never leave lightbox media playing
      document.removeEventListener('keydown', lbKeydown, true);
      lbEl.setAttribute('hidden', 'hidden');
      unlockScroll();
      var op = lbState.opener;
      var syncGallery = lbState.syncGallery;
      var idx = lbState.idx;
      lbState.opener = null;
      lbState.items = [];
      lbState.syncGallery = false;
      if (syncGallery) {
        setMainByIndex(idx);
        op = slideEl(idx);
      }
      // Gallery closes on the selected slide; other collections return to their opener.
      if (op && typeof op.focus === 'function') {
        try { op.focus({ preventScroll: true }); }
        catch (e) { try { op.focus(); } catch (ignore) {} }
      }
    }

    // A menu transition or page visibility change must never leave gallery or
    // lightbox audio playing behind another interface state.
    var p09MenuButton = $(root, '[data-menu-button]');
    if (p09MenuButton) {
      p09MenuButton.addEventListener('click', function () {
        stopAllVideos(null);
        lbPauseVideo();
      });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stopAllVideos(null); lbPauseVideo(); }
    });
    window.addEventListener('pagehide', function () {
      stopAllVideos(null);
      lbPauseVideo();
    });

    // Every slide (image AND video) opens the lightbox on click/Enter/Space.
    // The unmute overlay keeps its own behavior (it already stopPropagation()s;
    // the closest() check is a second guard).
    slides.forEach(function (sl, i) {
      sl.setAttribute('role', 'button');
      sl.setAttribute('aria-label', I18N.lbOpen);
      sl.style.cursor = 'zoom-in';
      sl.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-cln-unmute]')) return;
        openLb(galleryLbItems, i, sl, true);
      });
      sl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          openLb(galleryLbItems, i, sl, true);
        }
      });
    });

    // ---- color radio rows ---------------------------------------------------
    var ROW_ON  = 'border:2px solid var(--bronze);background:var(--bronze-tint);';
    var ROW_OFF = 'border:2px solid var(--hairline);background:var(--commerce);';
    function applyRowTail(btn, tail) {
      if (!btn) return;
      var css = btn.getAttribute('style') || '';
      css = css.replace(/border\s*:[^;]*;?/i, '').replace(/background\s*:[^;]*;?/i, '');
      css = css.replace(/;\s*;/g, ';').replace(/^\s*;/, '').trim();
      if (css && css.charAt(css.length - 1) !== ';') css += ';';
      btn.setAttribute('style', css + tail);
    }
    // L1 (w3c, t6a): "Geselecteerd"-hoekbadge in de HERO-buybox. Markup +
    // gereserveerde padding + i18n-label = B-SECTION-2 ([data-cln-sel-badge]
    // in de tegel/rij); JS toggelt ALLEEN zichtbaarheid, gekoppeld aan het
    // bestaande paint-mechanisme (paintRow + paintHero — uitbreiding, geen
    // gedragswijziging). No-op zolang de markup het attribuut niet heeft.
    function toggleSelBadge(btn, on) {
      if (!btn) return;
      var sb = btn.querySelector('[data-cln-sel-badge]');
      if (!sb) return;
      if (btn.style.position !== 'relative') btn.style.position = 'relative';
      if (on) { sb.removeAttribute('hidden'); sb.style.display = 'inline-flex'; }
      else    { sb.setAttribute('hidden', 'hidden'); sb.style.display = 'none'; }
    }
    function syncChoiceState(btn, on) {
      if (!btn) return;
      btn.dataset.selected = on ? 'true' : 'false';
      var input = btn.querySelector('input[type="radio"]');
      if (input) input.checked = Boolean(on);
    }
    function notifySelectionChange() {
      try {
        root.dispatchEvent(new CustomEvent('cln:pdp09-selection-change', {
          detail: {
            offer: state.offer,
            dev1: state.dev1,
            dev2: state.dev2
          }
        }));
      } catch (e) {}
    }
    function paintRow(btn, on) {
      if (!btn) return;
      syncChoiceState(btn, on);
      applyRowTail(btn, on ? ROW_ON : ROW_OFF);
      // radio indicator (dot + ring)
      var ring = btn.querySelector('[data-cln-radio]');
      var dot  = btn.querySelector('[data-cln-radio-dot]');
      if (ring) ring.style.borderColor = on ? 'var(--bronze)' : 'var(--hairline)';
      if (dot)  dot.style.background = on ? 'var(--bronze)' : 'transparent';
      toggleSelBadge(btn, on); // L1: badge volgt de bestaande paint-chain
    }
    // paint a device's pair of rows (hero + offer-form mirror) from a color
    function paintDevice(which, color) {
      var white = color === 'white';
      if (which === 'dev1') {
        paintRow(hDev1White, white); paintRow(hDev1Grey, !white);
        paintRow(fDev1White, white); paintRow(fDev1Grey, !white);
      } else {
        paintRow(hDev2White, white); paintRow(hDev2Grey, !white);
        paintRow(fDev2White, white); paintRow(fDev2Grey, !white);
      }
    }

    function setDevColor(which, color, opts) {
      state[which] = color;
      paintDevice(which, color);
      clearAtcError(); // a new selection clears any visible ATC error
      // I3c: color -> main-image jump for EVERY color row (dev1 AND dev2).
      // Clicking any of the 4 rows jumps the gallery to that color's slide
      // (White -> IDX_WHITE, Grey -> IDX_GREY). The 1x->2x seeding call in
      // setOffer() passes {noImage:true}, so seeding device 2 still never
      // moves the gallery. Variant selection / paint / cart-input sync are
      // untouched — device 2 keeps its own color state for the cart lines.
      if (!(opts && opts.noImage)) {
        var idx = color === 'white' ? IDX_WHITE : IDX_GREY;
        if (idx >= 0 && idx < SLIDE_COUNT) {
          // jump to the device-image slide (also pauses/mutes any playing video)
          setMainByIndex(idx);
        } else {
          // fallback: swap the src on the currently active image slide
          var src = imgFor(color);
          if (src) {
            stopAllVideos(null);
            swapMain(src);
            markThumb();
            updateCounter();
          }
        }
      }
      syncCartInputs();
      syncRecap(); // t6 (fase 2): mirror selection into the offer-recap card
      if (!(opts && opts.silent)) notifySelectionChange();
    }
    function bindDev(btn, which, color) {
      if (!btn) return;
      btn.addEventListener('click', function () { setDevColor(which, color); });
    }
    bindDev(hDev1White, 'dev1', 'white'); bindDev(hDev1Grey, 'dev1', 'grey');
    bindDev(hDev2White, 'dev2', 'white'); bindDev(hDev2Grey, 'dev2', 'grey');
    bindDev(fDev1White, 'dev1', 'white'); bindDev(fDev1Grey, 'dev1', 'grey');
    bindDev(fDev2White, 'dev2', 'white'); bindDev(fDev2Grey, 'dev2', 'grey');

    // ---- offer tile selected-state paint ------------------------------------
    // The big offer tiles ship with STATIC inline styles (1x looked permanently
    // selected). setOffer() previously only flipped aria-pressed, so the visible
    // highlight never moved. paintOffer() now rewrites border/background/shadow/
    // transform (mirroring the color-row paint pattern) plus a radio dot + a
    // "Geselecteerd" checkmark badge, so the selected state follows the click.
    var TILE_ON  = 'border:2px solid var(--bronze);background:var(--bronze-tint);' +
                   'box-shadow:0 16px 40px rgba(58,46,37,.18);transform:translateY(-2px);';
    var TILE_OFF = 'border:2px solid var(--hairline);background:var(--paper);' +
                   'box-shadow:none;transform:none;';
    function applyTileTail(btn, tail) {
      if (!btn) return;
      var css = btn.getAttribute('style') || '';
      css = css.replace(/border\s*:[^;]*;?/i, '')
               .replace(/background\s*:[^;]*;?/i, '')
               .replace(/box-shadow\s*:[^;]*;?/i, '')
               .replace(/transform\s*:[^;]*;?/i, '');
      css = css.replace(/;\s*;/g, ';').replace(/^\s*;/, '').trim();
      if (css && css.charAt(css.length - 1) !== ';') css += ';';
      btn.setAttribute('style', css + tail);
    }
    function paintTile(btn, on) {
      if (!btn) return;
      syncChoiceState(btn, on);
      applyTileTail(btn, on ? TILE_ON : TILE_OFF);
      var ring = btn.querySelector('[data-cln-offer-radio]');
      var dot  = btn.querySelector('[data-cln-offer-dot]');
      if (ring) ring.style.borderColor = on ? 'var(--bronze)' : 'var(--hairline)';
      if (dot)  dot.style.background   = on ? 'var(--bronze)' : 'transparent';
      var badge = btn.querySelector('[data-cln-offer-badge]');
      if (badge) {
        if (on) { badge.removeAttribute('hidden'); badge.style.display = 'inline-flex'; }
        else    { badge.setAttribute('hidden', 'hidden'); badge.style.display = 'none'; }
      }
    }
    function paintOffer(o) {
      paintTile(bigOff1, o === 1);
      paintTile(bigOff2, o === 2);
    }

    // ---- P0-1: HERO buybox offer-radio paint (tpl 34/37) ---------------------
    // Root cause (D1): the hero radios ship with STATIC inline border/background
    // (1x permanently bronze). setOffer() only flipped aria-checked, and no CSS
    // targets [aria-checked] — nor could it win against those inline styles.
    // Fix: repaint them inline on every setOffer(), exactly like the color rows
    // (same ROW_ON/ROW_OFF palette: bronze/bronze-tint vs hairline/commerce),
    // plus a JS-injected ring+dot so the selected state reads as a real radio.
    // paintOffer/paintTile stay frozen — this only EXTENDS the paint chain.
    function ensureHeroRadio(btn) {
      if (!btn || btn.querySelector('[data-cln-hero-radio]')) return;
      btn.style.position = 'relative';
      btn.style.paddingRight = '44px'; // keep label clear of the injected ring
      var ring = document.createElement('span');
      ring.setAttribute('data-cln-hero-radio', '');
      ring.setAttribute('aria-hidden', 'true');
      // L1: als de tegel een sel-badge heeft (rechtsboven-hoek), zakt de
      // injected ring onder de badge-strook zodat ze elkaar nooit overlappen.
      var ringTop = btn.querySelector('[data-cln-sel-badge]') ? '34px' : '13px';
      ring.style.cssText = 'position:absolute;top:' + ringTop + ';right:13px;width:18px;height:18px;' +
        'border-radius:999px;border:2px solid var(--hairline);background:var(--paper);' +
        'display:inline-flex;align-items:center;justify-content:center;pointer-events:none;';
      var dot = document.createElement('span');
      dot.setAttribute('data-cln-hero-dot', '');
      dot.style.cssText = 'width:8px;height:8px;border-radius:999px;background:transparent;';
      ring.appendChild(dot);
      btn.appendChild(ring);
    }
    function paintHero(btn, on) {
      if (!btn) return;
      syncChoiceState(btn, on);
      applyRowTail(btn, on ? ROW_ON : ROW_OFF);
      var ring = btn.querySelector('[data-cln-hero-radio]');
      var dot  = btn.querySelector('[data-cln-hero-dot]');
      if (ring) ring.style.borderColor = on ? 'var(--bronze)' : 'var(--hairline)';
      if (dot)  dot.style.background   = on ? 'var(--bronze)' : 'transparent';
      toggleSelBadge(btn, on); // L1: badge volgt de bestaande paint-chain
    }
    ensureHeroRadio(heroOff1);
    ensureHeroRadio(heroOff2);

    // ---- cart items + hidden-input sync -------------------------------------
    function cartItems() {
      if (state.offer === 2) {
        return [
          { id: variantFor(state.dev1), quantity: 1, properties: cloneProps() },
          { id: variantFor(state.dev2), quantity: 1, properties: cloneProps() }
        ];
      }
      return [ { id: variantFor(state.dev1), quantity: 1, properties: cloneProps() } ];
    }
    function cloneProps() {
      return {
        _mxr_offer: OFFER_PROPS._mxr_offer,
        _mxr_offer_route: OFFER_PROPS._mxr_offer_route,
        _mxr_offer_currency: OFFER_PROPS._mxr_offer_currency
      };
    }
    function syncCartInputs() {
      var items = cartItems();
      if (line0Id) {
        line0Id.value = items[0].id;
        if (line0Id.hasAttribute('data-cln-variant-id')) line0Id.setAttribute('data-cln-variant-id', items[0].id);
      }
      var two = state.offer === 2;
      if (line1Id) {
        line1Id.disabled = !two;
        line1Id.value = two && items[1] ? items[1].id : variantFor(state.dev2);
      }
      line1Props.forEach(function (inp) { inp.disabled = !two; });
    }

    // ---- offer toggle (hero radios + big cards stay in sync) ----------------
    function setOffer(o) {
      var prev = state.offer;
      state.offer = o;
      var one = o === 1;
      paintHero(heroOff1, one);  // P0-1: hero radios now repaint (aria + visual)
      paintHero(heroOff2, !one);
      paintOffer(o); // repaint big offer tiles (border/bg/shadow/radio/badge)
      clearAtcError(); // a new selection clears any visible ATC error
      setInterp(heroPrice, PRICES[o]);
      setInterp(stickyPr, PRICES[o]);

      // On 1x->2x: seed device 2 with device 1's color (sensible default).
      if (!one && prev !== 2) { setDevColor('dev2', state.dev1, { noImage: true, silent: true }); }

      // show/hide the second color row (hero) + the offer-form dual-color block.
      // The device-1 "Apparaat 1" label only shows in bundle mode (single = one clean row).
      if (hDev1Label) {
        if (one) { hDev1Label.setAttribute('hidden', 'hidden'); hDev1Label.style.display = 'none'; }
        else     { hDev1Label.removeAttribute('hidden'); hDev1Label.style.display = 'block'; }
      }
      if (dev2Wrap) {
        if (one) { dev2Wrap.setAttribute('hidden', 'hidden'); dev2Wrap.style.display = 'none'; }
        else     { dev2Wrap.removeAttribute('hidden'); dev2Wrap.style.display = 'flex'; }
      }
      if (dualColor) {
        if (one) { dualColor.setAttribute('hidden', 'hidden'); dualColor.style.display = 'none'; }
        else     { dualColor.removeAttribute('hidden'); dualColor.style.display = 'flex'; }
      }
      syncCartInputs();
      syncRecap(); // t6 (fase 2): mirror selection into the offer-recap card
      syncCloserCta(); // W4: tpl301 closer-CTA price mirrors the offer state
      notifySelectionChange();
    }
    if (heroOff1) heroOff1.addEventListener('click', function () { setOffer(1); });
    if (heroOff2) heroOff2.addEventListener('click', function () { setOffer(2); });
    if (bigOff1)  bigOff1.addEventListener('click', function () { setOffer(1); });
    if (bigOff2)  bigOff2.addEventListener('click', function () { setOffer(2); });

    // ---- I12: mechanism side toggle REMOVED ---------------------------------
    // The "linkerzijde/rechterzijde" buttons (tpl 99/100) did nothing useful
    // and are being removed from the markup by B-SECTION-2. All associated JS
    // (setSide/applySideTail/SIDESEL/SIDEOFF + tpl 95/96 glow handles) is
    // deleted here. Transition-safe by construction: setSide() was only ever
    // reachable via click listeners on the (soon gone) buttons, and it was
    // never called at init — the red glow (tpl 95/96) has always shipped its
    // visible state as server-rendered inline styles, which stay untouched.

    // ---- drawers + FAQ accordion (delegated) --------------------------------
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-toggle]') : null;
      if (!btn || !root.contains(btn)) return;
      var id = btn.getAttribute('aria-controls'); if (!id) return;
      var panel = document.getElementById(id); if (!panel) return;
      var isHidden = panel.hasAttribute('hidden');
      if (isHidden) {
        panel.removeAttribute('hidden');
        panel.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        panel.setAttribute('hidden', 'hidden');
        panel.setAttribute('aria-hidden', 'true');
        btn.setAttribute('aria-expanded', 'false');
      }
      var chev = btn.querySelector('[data-chev]');
      if (chev) chev.textContent = isHidden ? '−' : '+';
    });

    // ---- BRP-v70 P-07: default-open op desktop -------------------------------
    // Panels met [data-brp-default-open="desktop"] openen bij init op >=768px;
    // mobiel (<768px) blijft collapsed-by-default. Idempotent en defensief:
    // raakt alleen panels die op init nog hidden zijn.
    try {
      if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
        $all(root, '[data-toggle][data-brp-default-open="desktop"]').forEach(function (btn) {
          var pid = btn.getAttribute('aria-controls'); if (!pid) return;
          var pnl = document.getElementById(pid);
          if (!pnl || !pnl.hasAttribute('hidden')) return;
          pnl.removeAttribute('hidden');
          pnl.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
          var bchev = btn.querySelector('[data-chev]');
          if (bchev) bchev.textContent = '−';
        });
      }
    } catch (e) {}

    // ---- I6: drawer auto-collapse when scrolled past ------------------------
    // Covers ALL 15 [data-toggle] disclosure panels: the 7 depth drawers
    // (founder-story, technology, use-cases, company-support, certification-
    // safety, care-plus, secondary-faq) AND the 8 primary FAQ items (faqp-0..7).
    // Analyzed first (I6 brief): the primary FAQ has NO exclusive open-one-
    // at-a-time logic anywhere — the delegated [data-toggle] handler above is
    // the only toggle code on the page (the inline text/x-dc script is inert),
    // so adding this auto-close path cannot double-fire against it.
    // Behavior: a panel closes itself only when its OPEN content sits fully
    // ABOVE the viewport (rect.bottom <= 0) while the user scrolls DOWN.
    // Zero scroll-jump: the close happens off-screen (mxrDraw only animates on
    // open, so closing is animation-free by design, reduced-motion included)
    // and the layout shrink above the viewport is compensated in the SAME
    // frame by the exact document-height delta. While the smooth scroll-CTA
    // jump to #aanbod is in flight, closes are deferred until the scroll
    // settles (then swept), so the smooth animation is never cancelled and
    // the landing position stays correct.
    function lazyDrawerCollapse() {
    (function () {
      var panels = $all(root, 'button[data-toggle][aria-controls]')
        .map(function (b) { return document.getElementById(b.getAttribute('aria-controls')); })
        .filter(function (p) { return !!p; });
      if (!panels.length || !('IntersectionObserver' in window)) return;

      var dirDown = false;
      var lastY = window.pageYOffset || 0;
      var suppressed = false, settleTimer = null, suppressCap = null;

      function btnFor(panel) {
        return $(root, 'button[data-toggle][aria-controls="' + panel.id + '"]');
      }
      function closePanel(panel) {
        // BRP-v70 window-4 E-fix: measure the panel's OWN rendered height BEFORE
        // hiding (immune to batched-reflow scrollHeight double-counting) and guard
        // against a double close; compensate only when the panel sits fully above
        // the viewport, exactly once, so scroll stays put (zero jump).
        if (panel.hasAttribute('hidden')) return;
        var doc = document.documentElement;
        var r = panel.getBoundingClientRect();
        var aboveH = (r.bottom <= 0) ? r.height : 0;
        var y0 = window.pageYOffset || 0; // capture BEFORE hide, before any clamp
        panel.setAttribute('hidden', 'hidden');
        panel.setAttribute('aria-hidden', 'true');
        var btn = btnFor(panel);
        if (btn) {
          btn.setAttribute('aria-expanded', 'false');
          var chev = btn.querySelector('[data-chev]');
          if (chev) chev.textContent = '+';
        }
        if (aboveH > 0) {
          var prevSb = doc.style.scrollBehavior;
          doc.style.scrollBehavior = 'auto';
          window.scrollTo(0, Math.max(0, y0 - aboveH)); // absolute, deterministic, never double-clamps
          doc.style.scrollBehavior = prevSb;
          lastY = window.pageYOffset || 0; // don't let the correction flip dirDown
        }
      }
      function isPastAbove(panel) {
        if (panel.hasAttribute('hidden')) return false;
        var r = panel.getBoundingClientRect();
        return (r.height > 0 || r.width > 0) && r.bottom <= 0;
      }
      function sweep() {
        panels.forEach(function (p) { if (isPastAbove(p)) closePanel(p); });
      }

      var io = new IntersectionObserver(function (entries) {
        if (suppressed) return; // deferred: swept after the scroll settles
        entries.forEach(function (en) {
          var p = en.target;
          if (en.isIntersecting || p.hasAttribute('hidden')) return;
          // fully above the viewport AND user is scrolling down -> auto-close
          if (dirDown && en.boundingClientRect.bottom <= 0) closePanel(p);
        });
      }, { threshold: 0 });
      panels.forEach(function (p) { io.observe(p); });

      window.addEventListener('scroll', function () {
        var y = window.pageYOffset || 0;
        if (y !== lastY) dirDown = y > lastY;
        lastY = y;
        if (suppressed) {
          if (settleTimer) clearTimeout(settleTimer);
          settleTimer = setTimeout(function () {
            suppressed = false;
            if (suppressCap) { clearTimeout(suppressCap); suppressCap = null; }
            if (dirDown) sweep();
          }, 160);
        }
      }, { passive: true });

      // scroll-CTA click (header tpl11 / closer tpl301): defer auto-closes
      // until the programmatic smooth scroll is idle. Extra listener only —
      // the existing scroll-CTA handler above is untouched.
      root.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('[data-cln-scroll-cta]') : null;
        if (!a || !root.contains(a)) return;
        suppressed = true;
        if (suppressCap) clearTimeout(suppressCap);
        suppressCap = setTimeout(function () { // hard cap: never stay suppressed
          suppressed = false; suppressCap = null;
          if (dirDown) sweep();
        }, 3000);
      });
    })();
    }

    // ═══════ ISSUES-V2 FASE 2 (stemronde-winnaars) ═══════════════════════════
    // Markup-contract (B-SECTION-2): .p09-cmp/.p09-cmp-win/[data-cln-cmp-switch],
    // .p09-carousel/.p09-car-track/.p09-car-card/.p09-car-prev/.p09-car-next/
    // .p09-car-bar, [data-cln-recap-cta]/[data-cln-recap-offer|colors|price].
    // Every module below is a defensive no-op while the markup hooks are absent.

    // ---- t6: offer-recap (live selection mirror + scroll-CTA) ---------------
    // Single source of truth = the existing `state` (same source the sticky
    // CTA price uses). syncRecap() is called from setOffer()/setDevColor()
    // (extension calls only — their logic is untouched) and once at init.
    // Localization: offer label prefers markup-provided spans
    // [data-cln-recap-1x]/[data-cln-recap-2x] (JS only toggles visibility);
    // fallback writes the language-neutral "1×"/"2×". Color names are read
    // from the hero color-row labels (DOM = per-language source, no
    // hardcoded strings). Price comes from the PRICES map (market-formatted
    // by the section builder via data-cln-price-*).
    function recapColorName(color) {
      var btn = color === 'white' ? hDev1White : hDev1Grey;
      if (!btn) return '';
      var nameEl = btn.querySelector('[data-cln-color-name]');
      return (nameEl || btn).textContent.replace(/\s+/g, ' ').trim();
    }
    // ---- W4: closer-CTA (tpl301) price sync ---------------------------------
    // The final dark-section CTA renders a server-side label "<label> · <price>".
    // Mirror the price part from the same PRICES map the sticky bar uses; the
    // localized label prefix (up to and including the last middle dot) is
    // captured once from the server-rendered text, so no hardcoded strings.
    // Defensive no-op when the anchor or the separator is absent.
    function syncCloserCta() {
      var a = $(root, '[data-dc-tpl="301"]'); // BRP-v70 P-04: tpl301 is nu een buy-CTA
      if (!a) return;
      if (!a.__clnPricePrefix) {
        var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
        var i = t.lastIndexOf('·');
        if (i < 0) return; // no price segment -> leave the label untouched
        a.__clnPricePrefix = t.slice(0, i + 1) + ' ';
      }
      a.textContent = a.__clnPricePrefix + PRICES[state.offer];
    }
    function syncRecap() {
      var offEl = $(root, '[data-cln-recap-offer]');
      var colEl = $(root, '[data-cln-recap-colors]');
      var prEl  = $(root, '[data-cln-recap-price]');
      if (!offEl && !colEl && !prEl) return; // recap markup not (yet) present
      var two = state.offer === 2;
      if (offEl) {
        var o1 = offEl.querySelector('[data-cln-recap-1x]');
        var o2 = offEl.querySelector('[data-cln-recap-2x]');
        if (o1 || o2) {
          if (o1) { if (two) { o1.setAttribute('hidden', 'hidden'); o1.style.display = 'none'; }
                    else     { o1.removeAttribute('hidden'); o1.style.display = ''; } }
          if (o2) { if (two) { o2.removeAttribute('hidden'); o2.style.display = ''; }
                    else     { o2.setAttribute('hidden', 'hidden'); o2.style.display = 'none'; } }
        } else {
          offEl.textContent = two ? '2×' : '1×';
        }
      }
      if (colEl) {
        var n1 = recapColorName(state.dev1);
        if (two) {
          var n2 = recapColorName(state.dev2);
          colEl.textContent = (n1 && n2) ? (n1 + ' + ' + n2) : (n1 || n2 || '');
        } else {
          colEl.textContent = n1 || '';
        }
      }
      if (prEl) prEl.textContent = PRICES[state.offer];
    }
    // Recap-CTA: smooth-scroll UP to the hero buybox (tpl 29 column, has
    // scroll-margin-top in CSS for the sticky bar), then move focus to the
    // first offer tile (hero 1x radio, tpl 34) without re-scrolling.
    // Delegated, so it also works if the recap markup ships after this JS.
    // Upward scroll never triggers the I6 auto-collapse (direction guard).
    root.addEventListener('click', function (e) {
      var cta = e.target && e.target.closest ? e.target.closest('[data-cln-recap-cta]') : null;
      if (!cta || !root.contains(cta)) return;
      e.preventDefault();
      var target = $(root, '[data-dc-tpl="29"]') || colorUI || heroOff1;
      if (!target) return;
      target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      if (heroOff1) {
        try { heroOff1.focus({ preventScroll: true }); }
        catch (err) { try { heroOff1.focus(); } catch (e2) {} }
      }
    });

    // ---- t5-A: comparison-table mobile switcher (DOM-driven, per-language) --
    // Reads the existing .p09-cmp grid-table (role=table/row/cell): column 0 =
    // criteria, winner column = header with .p09-cmp-win (fallback: last
    // column; the class is then propagated to every cell of that column so
    // the CSS winner-treatment always lands). All remaining columns are
    // competitors. With 2+ competitors a segmented control is built into
    // [data-cln-cmp-switch] using the column-header TEXT as label (never
    // hardcoded -> per-language proof); default = header carrying
    // [data-cln-cmp-default] (the strongest competitor, marked by
    // B-SECTION-2), else the first competitor. Non-active competitor cells
    // get .p09-cmp-off (CSS hides them ONLY <920px). With a single
    // competitor no switcher is rendered (nothing to switch) and the mobile
    // 2-column reflow comes from CSS alone. The legacy .mxr-cmp-cards mobile
    // fallback is hidden as soon as a .p09-cmp table exists (JS fallback for
    // browsers without CSS :has()).
    function lazyComparison() {
    (function () {
      var cmp = $(root, '.p09-cmp');
      if (!cmp || cmp.__clnCmp) return;
      cmp.__clnCmp = true;
      var cards = $(root, '.mxr-cmp-cards');
      if (cards) { cards.style.display = 'none'; cards.setAttribute('aria-hidden', 'true'); }
      var rows = $all(cmp, '[role="row"]');
      if (!rows.length) return;
      var headers = Array.prototype.slice.call(rows[0].children);
      if (headers.length < 3) return; // criteria + at least 2 product columns
      var winIdx = -1;
      headers.forEach(function (h, i) { if (winIdx < 0 && h.classList.contains('p09-cmp-win')) winIdx = i; });
      if (winIdx < 0) winIdx = headers.length - 1; // convention: PX = last column
      rows.forEach(function (r) { // propagate winner class to every cell
        var c = r.children[winIdx];
        if (c) c.classList.add('p09-cmp-win');
      });
      var comps = [];
      headers.forEach(function (h, i) { if (i !== 0 && i !== winIdx) comps.push(i); });
      if (comps.length < 2) return; // single competitor: no switcher needed
      var mount = $(root, '[data-cln-cmp-switch]');
      if (!mount) return;
      function setActive(activeIdx) {
        rows.forEach(function (r) {
          comps.forEach(function (ci) {
            var cell = r.children[ci];
            if (!cell) return;
            if (ci === activeIdx) cell.classList.remove('p09-cmp-off');
            else cell.classList.add('p09-cmp-off');
          });
        });
        $all(mount, '.p09-cmp-seg').forEach(function (b) {
          b.setAttribute('aria-pressed', b.__clnCol === activeIdx ? 'true' : 'false');
        });
      }
      var defIdx = comps[0];
      comps.forEach(function (ci) {
        if (headers[ci].hasAttribute('data-cln-cmp-default')) defIdx = ci;
      });
      while (mount.firstChild) mount.removeChild(mount.firstChild); // idempotent rebuild
      comps.forEach(function (ci) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'p09-cmp-seg';
        b.textContent = headers[ci].textContent.replace(/\s+/g, ' ').trim();
        b.__clnCol = ci;
        b.addEventListener('click', function () { setActive(ci); });
        mount.appendChild(b);
      });
      setActive(defIdx);
    })();
    }

    // ---- t7-B: persona-carousel (scroll-snap + arrows + progressbar) --------
    // Native scroll-snap does the moving; JS only adds: arrow paging (one
    // card + gap per click, smooth unless reduced-motion), disabled-states at
    // both ends, a 2px progressbar (scaleX follows scrollLeft, rAF-throttled,
    // passive listener) and keyboard support (arrow keys while the track has
    // focus; track gets tabindex=0 if the markup didn't set one). No
    // autorotation, no libraries, touch stays 100% native.
    function lazyCarousel() {
    $all(root, '.p09-carousel').forEach(function (car) {
      if (car.__clnCar) return;
      car.__clnCar = true;
      var track = $(car, '.p09-car-track');
      if (!track) return;
      var prev = $(car, '.p09-car-prev');
      var next = $(car, '.p09-car-next');
      var bar  = $(car, '.p09-car-bar');
      var fill = null;
      if (bar) {
        fill = bar.querySelector('.p09-car-fill');
        if (!fill) {
          fill = document.createElement('span');
          fill.className = 'p09-car-fill';
          bar.appendChild(fill);
        }
        bar.setAttribute('aria-hidden', 'true'); // feedback only, not a control
      }
      function gapPx() {
        try { return parseFloat(getComputedStyle(track).columnGap) || 16; }
        catch (e) { return 16; }
      }
      function stepPx() {
        var c = track.querySelector('.p09-car-card');
        return (c ? c.getBoundingClientRect().width : track.clientWidth * 0.78) + gapPx();
      }
      function maxX() { return Math.max(0, track.scrollWidth - track.clientWidth); }
      function setDis(btn, dis) {
        if (!btn) return;
        btn.disabled = dis;
        btn.setAttribute('aria-disabled', dis ? 'true' : 'false');
      }
      var rafPending = false;
      function update() {
        rafPending = false;
        var x = track.scrollLeft, m = maxX();
        setDis(prev, m <= 1);
        setDis(next, m <= 1);
        if (fill) fill.style.transform = 'scaleX(' + (m > 0 ? Math.min(1, Math.max(0, x / m)) : 1) + ')';
      }
      function go(dir) {
        var m = maxX();
        if (m <= 1) return;
        var x = Math.max(0, Math.min(m, track.scrollLeft));
        if (dir < 0 && x <= 2) {
          track.scrollTo({ left: m, behavior: 'auto' });
        } else if (dir > 0 && x >= m - 2) {
          track.scrollTo({ left: 0, behavior: 'auto' });
        } else {
          track.scrollBy({ left: dir * stepPx(), behavior: REDUCED ? 'auto' : 'smooth' });
        }
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () {
        if (!rafPending) { rafPending = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', function () {
        if (!rafPending) { rafPending = true; requestAnimationFrame(update); }
      }, { passive: true });
      if (!track.hasAttribute('tabindex')) track.setAttribute('tabindex', '0');
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });
      update();
    });
    }

    // ---- C11: UGC-video's in de gedeelde fullscreen-lightbox ----------------
    // De playknop opent de UGC-collectie in dezelfde lightbox als de galerij en
    // herstelt focus naar de oorspronkelijke knop. De kaarten blijven poster-
    // first en autoplay-vrij; defensieve pause/observer-hooks blijven actief
    // voor native of externe playback. Idempotent via __clnUgc-guard per kaart.
    function lazyUgc() {
      var ugcCards = $all(root, '[data-cln-ugc-card]');
      if (!ugcCards.length) return;
      function ugcVidIn(card) { return card ? card.querySelector('video') : null; }
      var ugcLbItems = ugcCards.map(function (card) {
        return {
          node: card,
          video: ugcVidIn(card),
          image: card.querySelector('[data-cln-ugc-poster]')
        };
      });
      function ugcSetUi(card, playing) {
        if (!card) return;
        var btn = card.querySelector('[data-cln-ugc-play]');
        var ico = card.querySelector('[data-cln-ugc-play-ico]');
        var poster = card.querySelector('[data-cln-ugc-poster]');
        if (btn) {
          btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
          var lab = btn.getAttribute(playing ? 'data-cln-ugc-label-pause' : 'data-cln-ugc-label-play');
          if (lab) btn.setAttribute('aria-label', lab);
        }
        if (ico) ico.style.opacity = playing ? '0' : '';
        if (playing && poster) { poster.style.opacity = '0'; poster.style.pointerEvents = 'none'; }
      }
      function ugcPauseCard(card) {
        var v = ugcVidIn(card);
        if (v) { try { v.pause(); } catch (e) {} }
        ugcSetUi(card, false);
      }
      function ugcPauseOthers(exceptCard) {
        ugcCards.forEach(function (c) { if (c !== exceptCard) ugcPauseCard(c); });
        // ook alle galerij-video's stil (en weer gemute, hun default-staat)
        $all(root, '.cln-gallery-video').forEach(function (gv) {
          try { gv.pause(); } catch (e) {}
          gv.muted = true;
        });
      }
      ugcCards.forEach(function (card, cardIdx) {
        if (card.__clnUgc) return;
        card.__clnUgc = true;
        var v = ugcVidIn(card);
        var btn = card.querySelector('[data-cln-ugc-play]');
        if (!v || !btn) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          ugcPauseOthers(null);
          openLb([ugcLbItems[cardIdx]], 0, btn, false);
        });
        v.addEventListener('play', function () { ugcSetUi(card, true); });
        v.addEventListener('pause', function () { ugcSetUi(card, false); });
        v.addEventListener('ended', function () {
          try { v.currentTime = 0; } catch (e) {}
          ugcSetUi(card, false);
          var poster = card.querySelector('[data-cln-ugc-poster]');
          if (poster) { poster.style.opacity = ''; poster.style.pointerEvents = ''; }
        });
      });
      // (b) uit beeld -> pauze; alleen een SPELENDE video wordt aangeraakt.
      if ('IntersectionObserver' in window) {
        var ugcIO = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (en.isIntersecting) return;
            var v = ugcVidIn(en.target);
            if (v && !v.paused) ugcPauseCard(en.target);
          });
        }, { threshold: 0.35 });
        ugcCards.forEach(function (c) { ugcIO.observe(c); });
      }
    }

    // Bind UGC lightbox controls immediately so a fast click never falls back
    // to inline-only playback before the lazy module scheduler has run.
    lazyUgc();

    // ---- sticky mobile buy-bar ----------------------------------------------
    function showSticky(show) {
      if (!sticky || show === state.sticky) return;
      state.sticky = show;
      if (show) { sticky.removeAttribute('hidden'); sticky.setAttribute('aria-hidden', 'false'); }
      else      { sticky.setAttribute('hidden', 'hidden'); sticky.setAttribute('aria-hidden', 'true'); }
    }
    if (heroCta && sticky) {
      var upd = function () {
        var wh = window.innerHeight;
        var fr = footer ? footer.getBoundingClientRect() : null;
        var footVis  = fr && fr.top < wh;
        var primaryVisible = $all(root, '[data-cln-buy-cta]').some(function (cta) {
          if (cta.getAttribute('data-cln-atc-source') === 'sticky') return false;
          var cs = window.getComputedStyle ? window.getComputedStyle(cta) : null;
          if (cs && (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0')) return false;
          var r = cta.getBoundingClientRect();
          return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < wh && r.right > 0 && r.left < window.innerWidth;
        });
        showSticky(window.scrollY > 24 && !primaryVisible && !footVis);
      };
      window.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd, { passive: true });
      window.addEventListener('orientationchange', upd, { passive: true });
      upd();
    }

    // ---- scroll-reveal ------------------------------------------------------
    function lazyReveal() {
    var reveals = $all(root, '[data-reveal]');
    if (reveals.length) {
      if (REDUCED || !('IntersectionObserver' in window)) {
        reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
      } else {
        reveals.forEach(function (el) {
          el.style.opacity = '0';
          el.style.transform = 'translateY(22px)';
          el.style.transition = 'opacity .6s cubic-bezier(.23,1,.32,1), transform .6s cubic-bezier(.23,1,.32,1)';
        });
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (en.isIntersecting) { en.target.style.opacity = '1'; en.target.style.transform = 'none'; }
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
        reveals.forEach(function (el) { io.observe(el); });
        setTimeout(function () {
          reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
        }, 1600);
      }
    }
    }

    // ---- add-to-cart -> theme cart drawer (NO redirect) ---------------------
    // Verified live (maxorize.com, theme maxorize/main, liquid-ajax-cart):
    //   window.openCart()  -> adds body.js-show-ajax-cart + overflow-hidden, slides drawer in
    //   window.reloadCart()-> liquidAjaxCart.update() re-renders drawer contents
    //   drawer element ..... .maison_commerce-cart[data-ajax-cart-section]
    //   cart toggle ........ #cart-icon-bubble
    var buyBusy = false;
    var buyCtas = $all(root, '[data-cln-buy-cta]');
    var atcErrEl = null;

    // busy-state on ALL buy CTAs (hero button tpl45 / form submit tpl253 /
    // sticky anchor tpl321) + hard double-click guard via buyBusy.
    function setBuyBusy(b) {
      buyBusy = b;
      buyCtas.forEach(function (el) {
        el.setAttribute('aria-busy', b ? 'true' : 'false');
        if (typeof el.disabled === 'boolean') el.disabled = b;
        else el.setAttribute('aria-disabled', b ? 'true' : 'false'); // <a> CTA
        el.style.opacity = b ? '.6' : '';
        el.style.pointerEvents = b ? 'none' : '';
        el.style.cursor = b ? 'progress' : '';
        if (el.classList) el.classList.toggle('cln-atc-busy', !!b); // D1: zichtbare spinner-state
      });
    }
    // visible customer-facing error near the CTA that triggered the add;
    // cleared on any new offer/color selection (setOffer / setDevColor).
    function clearAtcError() {
      if (atcErrEl && atcErrEl.parentNode) atcErrEl.parentNode.removeChild(atcErrEl);
    }
    function showAtcError(near) {
      if (!atcErrEl) {
        atcErrEl = document.createElement('div');
        atcErrEl.className = 'cln-pdp09-atc-err';
        atcErrEl.setAttribute('role', 'alert');
      }
      atcErrEl.textContent = I18N.atcError;
      var anchor = (near && near.parentNode) ? near :
                   (buyForm ? $(buyForm, '[data-cln-buy-cta]') : null);
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(atcErrEl, anchor.nextSibling);
        // in a row-flex parent (sticky bar) let the message wrap to its own line
        try {
          if (window.getComputedStyle(anchor.parentNode).display.indexOf('flex') !== -1) {
            anchor.parentNode.style.flexWrap = 'wrap';
          }
        } catch (e) {}
      } else {
        root.appendChild(atcErrEl);
      }
    }

    function openThemeDrawer() {
      // 1) official theme API
      if (typeof window.openCart === 'function') { try { window.openCart(); return true; } catch (e) {} }
      // 2) click the theme cart toggle (liquid-ajax-cart opens on it)
      var tog = document.getElementById('cart-icon-bubble') ||
                document.querySelector('[id*="cart-icon"],a[href$="/cart"],[aria-label*="cart" i],[aria-label*="winkelwagen" i]');
      if (tog) { try { tog.click(); return true; } catch (e) {} }
      // 3) last-resort: flip the body classes the theme uses for the open state
      try {
        document.body.classList.add('js-show-ajax-cart');
        document.body.classList.add('overflow-hidden');
        document.body.style.overflow = 'hidden';
        return true;
      } catch (e) {}
      return false;
    }
    function refreshThemeDrawer() {
      // re-render the drawer markup via the theme runtime if available
      if (typeof window.reloadCart === 'function') { try { return Promise.resolve(window.reloadCart()); } catch (e) {} }
      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === 'function') {
        try { window.liquidAjaxCart.update(); } catch (e) {}
      }
      return Promise.resolve();
    }
    function addToCart(trigger) {
      if (buyBusy) return; // double-click guard
      clearAtcError();
      syncCartInputs();
      var items = cartItems();
      if (!items.length || !items[0].id) { showAtcError(trigger || null); return; } // D11: nooit stil falen
      // BRP-v70 P-04: tag de add met zijn CTA-bron (buybox|sticky|recap|final).
      // Niet-breaking: property wordt alleen toegevoegd als het attribuut bestaat.
      var atcSource = (trigger && trigger.getAttribute) ? trigger.getAttribute('data-cln-atc-source') : null;
      if (atcSource) {
        items.forEach(function (it) {
          it.properties = it.properties || {};
          it.properties._mxr_atc_source = atcSource;
        });
      }
      setBuyBusy(true); // loading-state (incl. zichtbare spinner) op elke buy-CTA
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      cartRoot = cartRoot.replace(/\/$/, '');
      // D1: AbortController + failsafe zodat een hangend netwerk NOOIT een permanente dead-state geeft
      var atcCtl = (typeof AbortController === 'function') ? new AbortController() : null;
      var atcFailsafe = setTimeout(function () {
        if (atcCtl) { try { atcCtl.abort(); } catch (e) {} }
        if (buyBusy) { setBuyBusy(false); showAtcError(trigger || null); }
      }, 10000);
      fetch(cartRoot + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
        signal: atcCtl ? atcCtl.signal : undefined
      }).then(function (res) {
        if (!res.ok) { return res.text().then(function () { throw new Error('cart/add ' + res.status); }); }
        // D1: succes staat vast -> failsafe uit en knop DIRECT vrijgeven (geen dead-click-venster meer).
        clearTimeout(atcFailsafe);
        setBuyBusy(false);
        // CLD-0088 P0+B2+HMACv2: Meta AddToCart. Browser-fbq (inert door de
        // pixel-brede browser-gate; activeert dedup-veilig als die opent) +
        // server-CAPI via de eigen adapter met BODY-BINDING: bh = SHA256(body)
        // reist in de app-proxy-getekende query, dus de body is tamper-proof
        // zonder client-secret. Gedeeld eventID = dedup/nonce. try/catch overal:
        // tracking mag de koopflow NOOIT breken.
        try {
          var mxrAtcId = 'mxr_atc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
          var mxrAtcValue = parseFloat(String(PRICES[state.offer] || '').replace(/[^0-9.,]/g, '').replace(',', '.'));
          if (!mxrAtcValue || isNaN(mxrAtcValue)) { mxrAtcValue = 249 * items.length; }
          var mxrAtcIds = items.map(function (it) { return String(it.id); });
          var mxrAtcCur = OFFER_PROPS._mxr_offer_currency || 'EUR';
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_type: 'product',
              content_ids: mxrAtcIds,
              contents: items.map(function (it) { return { id: String(it.id), quantity: it.quantity || 1 }; }),
              value: mxrAtcValue,
              currency: mxrAtcCur
            }, { eventID: mxrAtcId });
          }
          // Server-lane met body-binding (async SHA-256). Fail-closed consent-gate.
          (function () {
            var mxrCp = window.Shopify && window.Shopify.customerPrivacy;
            var mxrMarketingOk = false;
            try { mxrMarketingOk = !!(mxrCp && mxrCp.marketingAllowed && mxrCp.marketingAllowed()); } catch (mxrCpErr) {}
            if (!mxrMarketingOk || !window.fetch || !(window.crypto && window.crypto.subtle)) return;
            var mxrCookie = function (name) {
              var m2 = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
              return m2 ? decodeURIComponent(m2[1]) : null;
            };
            var mxrAtcBody = {
              schema: 'mxr-atc-v1',
              event_id: mxrAtcId,
              content_ids: mxrAtcIds,
              value: mxrAtcValue,
              currency: mxrAtcCur,
              event_source_url: window.location.href,
              user_agent: navigator.userAgent,
              consent: { marketing: true }
            };
            var mxrFbp = mxrCookie('_fbp'); if (mxrFbp) mxrAtcBody.fbp = mxrFbp;
            var mxrFbc = mxrCookie('_fbc'); if (mxrFbc) mxrAtcBody.fbc = mxrFbc;
            var mxrBodyStr = JSON.stringify(mxrAtcBody);
            window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(mxrBodyStr)).then(function (buf) {
              var mxrBh = Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
              window.fetch(window.location.origin + '/apps/mxr-web-pixel/shopify/web-pixel?bh=' + mxrBh, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: mxrBodyStr,
                keepalive: true
              }).catch(function () {});
            }).catch(function () {});
          })();
        } catch (mxrAtcErr) { /* tracking-fout mag de koopflow nooit raken */ }
        // D2: drawer-render/refresh is cosmetisch en volledig losgekoppeld van het add-resultaat:
        // een fout hierin mag nooit 'Toevoegen mislukt' tonen; de drawer opent hoe dan ook.
        fetch(cartRoot + '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ sections: CART_DRAWER_SECTION })
        }).catch(function () {}).then(function () {
          var p; try { p = refreshThemeDrawer(); } catch (e) { p = null; }
          return (p && p.catch) ? p.catch(function () {}) : p;
        }).then(function () {
          setTimeout(function () { openThemeDrawer(); }, 120);
        }).catch(function () {
          setTimeout(function () { openThemeDrawer(); }, 120);
        });
        return null;
      }).catch(function () {
        // ECHTE add-fout (server-rejectie/netwerk): knoppen vrij + zichtbare melding.
        clearTimeout(atcFailsafe);
        setBuyBusy(false);
        showAtcError(trigger || null);
      });
    }

    // offer-section form: intercept submit -> ATC + drawer
    if (buyForm) {
      buyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var t = (e.submitter && e.submitter.hasAttribute &&
                 e.submitter.hasAttribute('data-cln-buy-cta'))
                ? e.submitter : $(buyForm, '[data-cln-buy-cta]');
        addToCart(t);
      });
    }
    // every buy CTA (hero tpl45 / sticky tpl321 / and the form button is type=submit)
    buyCtas.forEach(function (el) {
      if (el.type === 'submit') return; // handled by the form submit listener
      el.addEventListener('click', function (e) { e.preventDefault(); addToCart(el); });
    });
    // scroll CTAs (header / closer): plain smooth-scroll to the offer, no add
    $all(root, '[data-cln-scroll-cta]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('aanbod');
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' }); }
      });
    });

    // ---- prime initial state once -------------------------------------------
    // showSlide(0) sets visibility, counter, thumb-marking AND autoplays slide 0
    // if it is a video (muted). If there are no slides it is a safe no-op.
    if (SLIDE_COUNT) { showSlide(0); } else { updateCounter(); markThumb(); }
    paintDevice('dev1', state.dev1);
    paintDevice('dev2', state.dev2);
    setOffer(state.offer);   // sets dual-color visibility + hidden inputs
    syncCartInputs();

    // ---- PERF fix 5: lazy-init non-critical modules -------------------------
    // Critical modules above already ran (gallery, buybox paint/offer/color,
    // sticky CTA, recap-sync, ATC). The four below are below-the-fold and don't
    // affect first paint or the buy flow, so they run OFF the DOMContentLoaded
    // critical path — deferred to idle time (requestIdleCallback, setTimeout
    // fallback) AND additionally triggered by an IntersectionObserver on each
    // module's own root so they are ready the moment the user scrolls near.
    // Every module is idempotent (own __clnCmp/__clnCar guards, or defensive
    // no-ops), so double-scheduling can never double-init.
    var lazyDone = false;
    function runLazy() {
      if (lazyDone) return;
      lazyDone = true;
      try { lazyDrawerCollapse(); } catch (e) {}
      try { lazyComparison(); } catch (e) {}
      try { lazyCarousel(); } catch (e) {}
      try { lazyUgc(); } catch (e) {}
      try { lazyReveal(); } catch (e) {}
    }
    // (a) IO on each module root: init as soon as its section approaches view.
    if ('IntersectionObserver' in window) {
      var lazyRoots = [];
      var cmpRoot = $(root, '.p09-cmp') || $(root, '.mxr-cmp-table');
      var carRoot = $(root, '.p09-carousel');
      if (cmpRoot) lazyRoots.push(cmpRoot);
      if (carRoot) lazyRoots.push(carRoot);
      var revRoot = $(root, '[data-reveal]');
      if (revRoot) lazyRoots.push(revRoot);
      if (lazyRoots.length) {
        var lazyIO = new IntersectionObserver(function (ents) {
          for (var i = 0; i < ents.length; i++) {
            if (ents[i].isIntersecting) { lazyIO.disconnect(); runLazy(); break; }
          }
        }, { rootMargin: '400px 0px' });
        lazyRoots.forEach(function (el) { lazyIO.observe(el); });
      }
    }
    // (b) idle fallback: guarantees init even without scroll / IO support.
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(runLazy, { timeout: 2500 });
    } else {
      setTimeout(runLazy, 1200);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('.cln-pdp09[data-cln-slot="CLN-PDP09"]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init when the Shopify section reloads in the theme editor / dynamic load.
  document.addEventListener('shopify:section:load', function (e) {
    // reset the init flag on the reloaded section so initRoot re-binds cleanly
    var sec = e && e.target;
    if (sec && sec.classList && sec.classList.contains('cln-pdp09')) { sec.__clnPdp09Init = false; }
    initAll();
  });
})();
